import { Button, Content, Flex, FlexItem, Stack, StackItem } from "@patternfly/react-core";
import type { FC } from "react";
import Env from "../../utils/env";

const ProductSupport: FC = () => {
	return (
		<Stack hasGutter={true} data-analytics-category="Product Info|Tabs|Support">
			<StackItem>
				<Content>
					<Content component="h2">Partner Support</Content>
					<Content component="p">
						The Partner Acceleration Desk (PAD) is a Products and Technologies (PnT) level partner help desk and
						provides a central ‘get help’ capability for current and prospective partners to ask queries throughout
						their journey with Red Hat.
					</Content>
				</Content>
			</StackItem>
			<StackItem>
				<Flex>
					<FlexItem>
						<Button variant={"primary"} component={"a"} href={`${Env.padUrl}`} target={"_blank"}>
							Open a support case
						</Button>
					</FlexItem>
					<FlexItem>
						<Button variant={"secondary"} component={"a"} href={`${Env.padCaseListUrl}`} target={"_blank"}>
							View support cases
						</Button>
					</FlexItem>
				</Flex>
			</StackItem>
		</Stack>
	);
};
export default ProductSupport;
